import React from "react";

import { StyledMarker, StyledMarkerProps } from "./styles";

export const MarkerIcon: React.FC<StyledMarkerProps> = props => <StyledMarker {...props} />;
